<template>
  <div class="form-floating">
    <textarea
      :id="name"
      ref="textarea"
      class="form-control overflow-hidden"
      rows="1"
      style="resize: none"
      :class="{ 'is-invalid': errors }"
      :maxlength="max"
      :name="name"
      :value="value"
      :placeholder="label"
      :data-attribute="attribute"
      @keypress="isLetter($event)"
      @change="$emit('update:data', $event)"
      @focus="resize"
      @keyup="resize"
    >
    </textarea>
    <label v-if="label">{{ label }}</label>
    <div v-for="(error, index) in errors" :key="index" class="invalid-feedback" role="alert">
      <strong>{{ error }}</strong>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
export default {
  props: {
    attribute: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:data'],
  setup(props) {
    const textarea = ref(null);
    const resize = () => {
      textarea.value.style.height = '1px';
      textarea.value.style.height =
        Math.max(
          (props.rows + 3) * parseFloat(getComputedStyle(document.documentElement).fontSize),
          parseInt(textarea.value.scrollHeight)
        ) +
        2 +
        'px';
    };
    onMounted(() => {
      resize();
    });

    const isLetter = (e) => {
      let char = String.fromCharCode(e.keyCode);
      if (/^[^<^>]+$/.test(char)) return true;
      else e.preventDefault();
    };

    return { textarea, resize, isLetter };
  },
};
</script>

<style lang="scss" scoped></style>
